<template>
  <div>
    <slot />
  </div>
</template>
<script setup>

</script>
<style scoped lang="less">
</style>
